import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "m-0 shrink-0 flex items-center justify-between"
};
const _hoisted_2 = {
  class: "flex items-center gap-2"
};
const _hoisted_3 = {
  class: "w-full min-h-full relative flex-grow bg-white box-border p-3 sm:p-7"
};
import { useClipboard } from '@vueuse/core';
import { computed, ref, watch } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Write',
  props: {
    content: {
      // 生成的结果
      type: String,
      default: ''
    },
    isWriting: {
      // 是否正在生成文章
      type: Boolean,
      default: false
    }
  },
  emits: ['update:content', 'stopStream', 'handle-close'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const {
      copied,
      copy
    } = useClipboard(); // 粘贴板
    const props = __props;
    const emits = __emit;
    /** 通过计算属性，双向绑定，更改生成的内容，考虑到用户想要更改生成文章的情况 */
    const compContent = computed({
      get() {
        return props.content;
      },
      set(val) {
        emits('update:content', val);
      }
    });
    /** 滚动 */
    const contentRef = ref();
    __expose({
      scrollToBottom() {
        contentRef.value?.scrollTo(0, contentRef.value?.scrollHeight);
      }
    });
    const back = () => {
      emits('handle-close');
    };
    /** 点击复制的时候复制内容 */
    const showCopy = computed(() => props.content && !props.isWriting); // 是否展示复制按钮，在生成内容完成的时候展示
    const copyContent = () => {
      copy(props.content);
    };
    /** 复制成功的时候 copied.value 为 true */
    watch(copied, val => {
      if (val) {
        message.success('复制成功');
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        class: "my-card h-full"
      }, {
        header: _withCtx(() => [_createElementVNode("h3", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: back,
          size: "small"
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "mynaui:fat-arrow-left"
          })]),
          _: 1
        }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "预览", -1))]), _withDirectives(_createVNode(_component_el_button, {
          color: "#846af7",
          onClick: copyContent,
          size: "small"
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "ph:copy-bold"
          })]),
          default: _withCtx(() => [_cache[3] || (_cache[3] = _createTextVNode(" 复制 "))]),
          _: 1
        }, 512), [[_vShow, showCopy.value]])])]),
        default: _withCtx(() => [_createElementVNode("div", {
          ref_key: "contentRef",
          ref: contentRef,
          class: "hide-scroll-bar h-full box-border overflow-y-auto"
        }, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createVNode(_component_el_button, {
          class: "absolute bottom-2 sm:bottom-5 left-1/2 -translate-x-1/2 z-36",
          onClick: _cache[0] || (_cache[0] = $event => emits('stopStream')),
          size: "small"
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "material-symbols:stop"
          })]),
          default: _withCtx(() => [_cache[4] || (_cache[4] = _createTextVNode(" 终止生成 "))]),
          _: 1
        }, 512), [[_vShow, __props.isWriting]]), _createVNode(_component_el_input, {
          id: "inputId",
          type: "textarea",
          modelValue: compContent.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => compContent.value = $event),
          autosize: "",
          "input-style": {
            boxShadow: 'none'
          },
          resize: "none",
          placeholder: "生成的内容……"
        }, null, 8, ["modelValue"])])], 512)]),
        _: 1
      });
    };
  }
});